import React from 'react';
import Icon from '../../../components/AppIcon';

const MapStats = ({ activeFilters, totalSites = 6 }) => {
  // Calculate visible sites based on filters
  const getVisibleCount = () => {
    if (activeFilters?.showAll) return totalSites;
    
    let count = 0;
    if (activeFilters?.cultural) count += 3; // 3 cultural sites in mock data
    if (activeFilters?.natural) count += 3;   // 3 natural sites in mock data
    
    return count;
  };

  const visibleSites = getVisibleCount();
  const culturalCount = activeFilters?.cultural || activeFilters?.showAll ? 3 : 0;
  const naturalCount = activeFilters?.natural || activeFilters?.showAll ? 3 : 0;

  const stats = [
    {
      id: 'total',
      label: 'Total Sites',
      value: visibleSites,
      icon: 'MapPin',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      id: 'cultural',
      label: 'Cultural Heritage',
      value: culturalCount,
      icon: 'Building2',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      id: 'natural',
      label: 'Natural Heritage',
      value: naturalCount,
      icon: 'Trees',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-card p-4 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="BarChart3" size={20} className="text-primary" />
        <h3 className="font-heading font-semibold text-base text-foreground">
          Map Statistics
        </h3>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {stats?.map((stat) => (
          <div key={stat?.id} className="flex items-center gap-3 p-3 rounded-lg bg-muted/30">
            <div className={`p-2 rounded-full ${stat?.bgColor}`}>
              <Icon name={stat?.icon} size={16} className={stat?.color} />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-foreground">{stat?.label}</p>
              <p className="text-xs text-muted-foreground">Currently visible</p>
            </div>
            <div className="text-right">
              <p className={`text-lg font-bold ${stat?.color}`}>{stat?.value}</p>
              <p className="text-xs text-muted-foreground">sites</p>
            </div>
          </div>
        ))}
      </div>
      {/* Filter Status */}
      <div className="mt-4 pt-3 border-t border-border">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Active filters:</span>
          <div className="flex gap-1">
            {activeFilters?.showAll && (
              <span className="px-2 py-1 bg-primary/10 text-primary rounded-full text-xs font-medium">
                All
              </span>
            )}
            {!activeFilters?.showAll && activeFilters?.cultural && (
              <span className="px-2 py-1 bg-accent/10 text-accent rounded-full text-xs font-medium">
                Cultural
              </span>
            )}
            {!activeFilters?.showAll && activeFilters?.natural && (
              <span className="px-2 py-1 bg-success/10 text-success rounded-full text-xs font-medium">
                Natural
              </span>
            )}
            {!activeFilters?.showAll && !activeFilters?.cultural && !activeFilters?.natural && (
              <span className="px-2 py-1 bg-muted text-muted-foreground rounded-full text-xs font-medium">
                None
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapStats;